// @ts-check

const SPLIT_CSV_VALUE_WITH_QUOTE = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;

/** @param {string} fileName */
function removeFileExtension(fileName) {
  return fileName.replace(/\.[^.]*$/, '');
}

/**
 * @param {string} pathName
 * @param {boolean} [removeExtension=true]
 * @return {string}
 */
function parseCSVFileName(pathName, removeExtension = true) {
  let fileName = pathName ? pathName.match(/[^\\/*?"<>|\r\n]+$/)[0] : '';
  if (removeExtension) {
    fileName = removeFileExtension(fileName);
  }
  return fileName;
}

/**
 * @param {{ headers: string[], rows: string[] }} param
 */
function mapCsvTableToJson({ headers, rows }) {
  return rows
    .filter((row) => row !== '')
    .map((row) => {
      // Map the rows
      const rawValues = row.split(SPLIT_CSV_VALUE_WITH_QUOTE);
      const values = rawValues.map((value) => value.replace(/"/g, ''));
      // object properties derived from headers:values
      const rowItem = headers.reduce(function (object, header, index) {
        object[header] = values[index];
        return object;
      }, {});
      return rowItem;
    });
}

/**
 * @param {CampaignModel} campaign
 */
function makeCsvFileNameUnique(campaign) {
  let fileName = campaign.csvFile.fileNameNoExt;
  const similarNames = (campaign.details.sources || []).filter((source) =>
    source.filename.includes(fileName),
  );

  if (similarNames.length > 0) {
    fileName = `${fileName}_${similarNames.length + 1}`;
  }

  return fileName;
}

export {
  mapCsvTableToJson,
  parseCSVFileName,
  makeCsvFileNameUnique,
  removeFileExtension,
  SPLIT_CSV_VALUE_WITH_QUOTE,
};
